import { Navigate } from "react-router-dom";

import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import { orchestrationPathResources } from "../../orchestrationPaths";
import RoutingRulesRouter from "../RoutingRulesRouter";
import { RoutingRulesPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const OrchestrationRoutingRules = lazyWithRetries(
    "Orchestration RoutingRules page",
    () => import(/* webpackChunkName: "OrchestrationRoutingRules" */ "./RoutingRulesPage/RoutingRulesPage")
);

const RoutingRuleEditPage = lazyWithRetries(
    "RoutingRuleEdit page",
    () => import(/* webpackChunkName: "RoutingRuleEditPage" */ "./RoutingRulesPage/RoutingRuleEditPage")
);

const TaskAttributes = lazyWithRetries(
    "TaskAttributes page",
    () =>
        import(
            /* webpackChunkName: "TaskAttributes" */ "./OrchestrationTaskAttributesPage/OrchestrationTaskAttributesPage"
        )
);

const OrchestrationCreateQueuePage = lazyWithRetries(
    "OrchestrationCreateQueuePage page",
    () =>
        import(
            /* webpackChunkName: "OrchestrationCreateQueuePage" */ "./QueuesListPage/Pages/EditQueuePage/OrchestrationEditQueuesPage"
        )
);

const QueuesPage = lazyWithRetries(
    "QueuesPage page",
    () => import(/* webpackChunkName: "QueuesPage" */ "./QueuesListPage/QueuesListPage")
);

// Route for orchestration section
export const orchestrationRoutingRulesRoute: RegalRouteObject = {
    path: `${orchestrationPathResources.routing}/*`,
    element: <RoutingRulesRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <Navigate to={RoutingRulesPaths.rules} replace />,
        },
        {
            path: RoutingRulesPaths.ruleByTypeVersion,
            element: <RoutingRuleEditPage />,
        },
        {
            path: RoutingRulesPaths.ruleByType,
            element: <RoutingRuleEditPage />,
        },
        {
            path: RoutingRulesPaths.rules,
            element: <OrchestrationRoutingRules />,
        },
        {
            path: RoutingRulesPaths.queues,
            element: <QueuesPage />,
        },
        {
            path: RoutingRulesPaths.attributes,
            element: <TaskAttributes />,
        },
        {
            path: RoutingRulesPaths.createQueue,
            element: <OrchestrationCreateQueuePage />,
        },
    ],
};
